export const isLocalhost = (): boolean => {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === ""
  ) {
    return true;
  }

  return false;
};

export const classNames = (...classes: any) => {
  return classes.filter(Boolean).join(" ");
};

export const mergeErrors = (errors: any) => {
  const merged: any = {};
  for (const key in errors.params) {
    if (errors.params.hasOwnProperty(key)) {
      merged[key] = merged[key] || [];
      merged[key] = merged[key].concat(errors.params[key]);
    }
  }

  for (const key in errors.body) {
    if (errors.body.hasOwnProperty(key)) {
      merged[key] = merged[key] || [];
      merged[key] = merged[key].concat(errors.body[key]);
    }
  }

  return merged;
};

export const camelToDash = (str: string) => {
  if (str !== str.toLowerCase()) {
    str = str.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase());
  }

  return str;
};

export const camelToUnderscore = (str: string) => {
  if (str !== str.toLowerCase()) {
    str = str.replace(/[A-Z]/g, (m) => "_" + m.toLowerCase());
  }

  return str;
};

export const createAbortController = () => {
  const abortController = new AbortController();
  const abortSignal = abortController.signal;
  return { abortController, abortSignal };
};

export const stripEmptyProperties = (obj: any) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== undefined && value !== ""
    )
  );
};
